<template>
    <div>
        <header class="rbt-dashboard-header rainbow-header header-default header-left-align rbt-fluid-header">
            <div class="container-fluid position-relative">
                <div class="row align-items-center">
                    <div class="col-lg-2 col-md-6 col-6">
                        <div class="header-left d-flex">
                            <div class="expand-btn-grp d-flex d-sm-none">
                                <button class="bg-solid-primary popup-dashboardleft-btn"><i class="feather-sidebar left"></i></button>
                            </div>
                            <div class="logo">
                                <a href="/Home">
                                    <img class="logo-light" src="assets/images/sollai/logo.png" alt="Corporate Logo">
                                    <img class="logo-dark" src="assets/images/sollai/logo.png" alt="Corporate Logo">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col d-flex justify-content-center responsive-mr">
                        <p class="mb-0 txt-p txt-size-14  d-none d-lg-block" v-if="msgManutencao">
                            Olá! Aqui é Sollai, a 1ª IA especialista em licitações e contratos do Brasil. Estou passando por uma atualização e treinamento em minha base, o que pode causar algumas oscilações em meu desempenho. Agradeço pela sua compreensão e estou trabalhando para retornar ao meu melhor estado o mais breve possível.
                        </p>
                        <nav class="mainmenu-nav d-none d-lg-block text-center">
                            <ul class="mainmenu d-none">
                                <li><a href="/">Home</a></li>
                                <li><a href="#">Sobre nós</a></li>
                                <li><a href="#">Como Funciona</a></li>
                                <li><a href="#">FAQ</a></li>
                                <li><a href="#">Contatos</a></li>
                                <li><a href="">Suporte</a></li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-auto col-sm-3 col-xl-2">
                        <div class="header-right">
                            <!-- Start admin Area  -->
                            <div class="account-access rbt-user-wrapper right-align-dropdown">
                                <div class="rbt-user c-pointer">
                                    <a class="admin-img me-3" href="#"><img src="assets/images/sollai/team-01.jpg" alt="Admin"></a>
                                    <div class=" d-none d-lg-flex flex-column">
                                        <h6 class="text-start mb-0">{{primeiroNome}}</h6>
                                        <p class="txt-size-10 mb-0">{{user.usuario.dsEmail}}</p>
                                    </div>
                                </div>
                                <div class="rbt-user-menu-list-wrapper">
                                    <div class="inner">
                                        <div class="rbt-admin-profile">
                                            <div class="admin-thumbnail">
                                                <img src="assets/images/sollai/team-01.jpg" alt="User Images">
                                            </div>
                                            <div class="admin-info">
                                                <span class="name"><b>{{primeiroNome}}</b></span>
                                                <p class="txt-size-10 mb-0">{{user.usuario.dsEmail}}</p>
                                                <!--<a class="rbt-btn-link color-primary" href="profile-details.html">View Profile</a>-->
                                            </div>
                                        </div>
                                        <ul class="user-list-wrapper user-nav">
                                            <li>
                                                <a href="javascript:void(0)" @click="showModalDados = !showModalDados">
                                                    <i class="feather-user"></i>
                                                    <span>Dados</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" @click="showModalSenha = !showModalSenha">
                                                    <i class="feather-lock"></i>
                                                    <span>Mudar senha</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" @click="showModalMetodo = !showModalMetodo">
                                                    <i class="feather-book-open"></i>
                                                    <span>Método de trabalho</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" @click="showManualUsuario = !showManualUsuario">
                                                    <i class="feather-book-open"></i>
                                                    <span>Manual do Usuário</span>
                                                </a>
                                            </li>
                                            <li v-if="isAdmContrato == 'Sim'">
                                                <a href="javascript:void(0)" @click="acao('GerenciarUsuarios')">
                                                    <i class="feather-users"></i>
                                                    <span>Gerenciar Usuários</span>
                                                </a>
                                            </li>
                                            <li v-if="isAdmContrato == 'Sim' || user.usuario.idContrato == 0">
                                                <!--v-if="isAdmContrato == 'Sim'"-->
                                                <a href="javascript:void(0)" @click="acao('RelatorioUso')">
                                                    <i class="feather-file-text"></i>
                                                    <span>Relatório de Uso</span>
                                                </a>
                                            </li>
                                            <li v-if="isAdmContrato == 'Sim' || user.usuario.idContrato == 0 || user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br'">
                                                <a href="javascript:void(0)" @click="showModalNormativa = !showModalNormativa">
                                                    <i class="feather-file-plus"></i>
                                                    <span>Normativa</span>
                                                </a>
                                            </li>
                                            <li v-if="user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br' || user.usuario.dsLogin == 'jefferson.lima'
                                                || user.usuario.dsLogin == 'gleyson.siqueira'">
                                                <a href="javascript:void(0)" @click="showModalTeste = !showModalTeste">
                                                    <i class="feather-file-plus"></i>
                                                    <span>Teste</span>
                                                </a>
                                            </li>
                                        </ul>
                                        <hr class="mt--10 mb--10">
                                        <!--<ul class="user-list-wrapper user-nav">
                                        <li>
                                            <a href="#">
                                                <i class="feather-help-circle"></i>
                                                <span>Help Center</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="profile-details.html">
                                                <i class="feather-settings"></i>
                                                <span>Settings</span>
                                            </a>
                                        </li>
                                    </ul>-->
                                        <ul class="user-list-wrapper user-nav" v-if="user.usuario.tpPessoa == 'J' && user.usuario.flCortesia != 'Sim'">
                                            <li v-if="user.usuario.idContrato != null && user.usuario.idPessoa != null">
                                                <a :href="urlSuporte+'p_idContrato='+user.usuario.idContrato+'&amp;p_idPessoa='+user.usuario.idPessoa" target="_blank">
                                                    <i class="feather-phone-outgoing"></i>
                                                    <span>Falar com o suporte</span>
                                                </a>
                                            </li>
                                        </ul>


                                        <hr class="mt--10 mb--10">
                                        <ul class="user-list-wrapper">
                                            <li>
                                                <a href="javascript:void(0)" @click="sair">
                                                    <i class="feather-log-out"></i>
                                                    <span>Sair</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="expand-btn-grp d-flex d-sm-none @@display-class">
                                <button class="bg-solid-primary popup-dashboardright-btn">
                                    <i class="feather-sidebar right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="popup-mobile-menu">
            <div class="inner-popup">
                <div class="header-top">
                    <div class="logo">
                        <a href="index.html">
                            <img class="logo-light" src="assets/images/sollai/logo.png" alt="Corporate Logo">
                            <img class="logo-dark" src="assets/images/sollai/logo.png" alt="Corporate Logo">
                        </a>
                    </div>
                    <div class="close-menu">
                        <button class="close-button">
                            <i class="feather-x"></i>
                        </button>
                    </div>
                </div>

                <div class="content">
                    <div class="rbt-sm-separator"></div>
                    <div class="rbt-default-sidebar-wrapper">
                        <div class="rbt-sm-separator"></div>

                        <nav class="mainmenu-nav">
                            <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                <li class="has-submenu">
                                    <a class="collapse-btn collapsed" data-bs-toggle="collapse"
                                       href="#collapseExampleMenu" role="button" aria-expanded="false"
                                       aria-controls="collapseExampleMenu"><i class="feather-plus-circle"></i><span>Setting</span></a>
                                    <div class="collapse" id="collapseExampleMenu">
                                        <ul class="submenu rbt-default-sidebar-list">
                                            <li>
                                                <a href="profile-details.html">
                                                    <i class="feather-user"></i>
                                                    <span>Dados</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li><a href="#"><i class="feather-award"></i><span>Help e FAQ</span></a></li>
                            </ul>
                            <div class="rbt-sm-separator"></div>
                            <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                <li>
                                    <a href="release-notes.html">
                                        <i class="feather-bell"></i><span>
                                            Release
                                            notes
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="terms-policy.html">
                                        <i class="feather-briefcase"></i><span>
                                            Terms &
                                            Policy
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <!-- Start Header Btn  -->
                <div class="header-btn d-block d-md-none">
                    <a class="btn-default @@btnClass" target="_blank" href="index.html">
                        Get Started
                        Free
                    </a>
                </div>
                <!-- End Header Btn  -->
            </div>
        </div>

        <MudarSenha :showModal="showModalSenha"></MudarSenha>
        <MeusDados :showModal="showModalDados"></MeusDados>
        <ModalNormativa :showModal="showModalNormativa"></ModalNormativa>

        <MetodoTrabalho :showModal="showModalMetodo"></MetodoTrabalho>
        <ManualUsuario :showModal="showManualUsuario"></ManualUsuario>
        <ModalTeste :showModal="showModalTeste"></ModalTeste>
    </div>
</template>

<script>

    import MudarSenha from '@/components/MudarSenha'
    import MeusDados from '@/components/MeusDados'
    import ModalNormativa from '@/components/ModalNormativa'
    import MetodoTrabalho from '@/components/MetodoTrabalho'
    import ModalTeste from '@/components/ModalTeste'
    import ManualUsuario from '@/components/ManualUsuario'

    import { urlApi, avisoErro, msgManutencao, urlSuporte } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Header',
        components: { MudarSenha, MeusDados, MetodoTrabalho, ModalNormativa, ModalTeste, ManualUsuario },
        props: {
            acao: Function,
        },
        computed: {
            user() {
                return this.$store.state.user
            },
                        
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },

            tpPessoa() {
                return this.$store.state.tpPessoa
            },

            primeiroNome() {
                if (this.user && this.user.usuario) {
                    if (this.user.usuario.nmUsuario) {
                        return this.user.usuario.nmUsuario.split(" ")[0]
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }

            },
        },
        data: function () {
            return {
                showModalSenha: false,
                showModalDados: false,
                showModalMetodo: false,
                showModalNormativa: false,
                showModalTeste: false,
                showManualUsuario: false,

                routes: this.$router.options.routes.filter(x => x.meta != undefined && x.meta.authenticated == false),
                urlGrupo: 'https://negociospublicos.com.br/',    
                msgManutencao: msgManutencao,
                urlSuporte: urlSuporte,
            }
        },
        methods: {
            subIsActive(input) {
                let name = this.$route.name.split('-')[0];
                return name == input.name;
            },
            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            },

            scrolToDiv(id) {
                document.getElementById(id).scrollIntoView();
            },

            sair() {
                let $this = this;
                axios.get(`${urlApi}/Auth/revoke`)
                    .then(function () {
                        $this.$store.commit('setUser', null)
                        location.reload();
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },
        },
        mounted: function () {
            
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
   
</style>

